import axios from "axios"


const BASE_URL = `/api`

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API call error:", error);
     if (error.response && error.response.status === 401) {
      
      window.location.href = '/Home';  // Redirect without hooks
    }
    return Promise.reject(error);
  }
);




export const GetApi = async (url, userToken) => {
  const apiUrl = `${BASE_URL}${url}`;
  const headers = {};
  if (userToken) {
    headers.Authorization = `Bearer ${userToken}`;
  }
  try {
    const response = await axios.get(apiUrl, {
      headers,
    });
    if (response.status === 200 || response.status === 201 || response.status === 304) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
};



export const PostApi = async (url,formData,userToken) => {
  try {
    console.log(`Url is : ${BASE_URL}${url}`)
    const response = await axios.post(`${BASE_URL}${url}`, formData, {
       headers: {
                Authorization: `Bearer ${userToken}`
              },
    });

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error in PostApi:", error.response?.data?.error || error.message);
    throw new Error(error.response?.data?.error);
  }
};

export default PostApi;



export const PutApi = async (url, params = {}, formData, token) => {
  try {
    const queryString = Object.keys(params).length
      ? "?" +
        Object.entries(params)
          .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
          .join("&")
      : "";

    const endpoint = `${BASE_URL}${url}${queryString}`;

    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.put(endpoint, formData, { headers });

    if ([200, 201, 204].includes(response.status)) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

export const DeleteApi = async (url, params = {}, token) => {
  try {
    const queryString = Object.keys(params).length
      ? "?" +
        Object.entries(params)
          .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
          .join("&")
      : "";

    const endpoint = `${BASE_URL}${url}${queryString}`;

    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.delete(endpoint, { headers });

    if ([200, 201, 204].includes(response.status)) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
};

